const colors = {
  white: "#fff",
  black: "#000",
  denim: "#191E23",
  orange: "#FFA100",
  spruce: "#232D39",
  slate: "#303439",
  halfWhite: "#8C8E91",
  red: "#FA3E3E",
  link: "#1D9BF0",
}

export default colors